import { Button, IconButton, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import Iconify from "../../../minimals/components/iconify";
import { formatUTCDateWithLocalTime } from "../../../utils";
import BulletinRowData from "../BulletinRowData";
import { createMatchResolutionRequestColumn } from "../MatchResolution/MatchResolutionRequestColumn";
import { createRemovalRequestColumn } from "../RemovalRequest/RemovalRequestColumn";
import { BlacklistEntityType, PersonRecord, RemovalRequest } from "../types";


export const personRecordColumns = (refreshData: () => Promise<void>, onEdit?: (entityId: number) => void): MRT_ColumnDef<PersonRecord>[] => [
  ...(onEdit ? [{
    id: "edit",
    header: "",
    size: 80,
    enableSorting: false,
    enableColumnFilter: false,
    Cell: ({ row }: any) => (
      <IconButton onClick={() => onEdit(row.original.id)}>
        <Iconify icon={"eva:edit-fill"} />
     </IconButton>
    ),
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } }
  }] as MRT_ColumnDef<PersonRecord>[] : []),
  {
    accessorKey: "id",
    header: "ID",
    size: 5,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  createRemovalRequestColumn<PersonRecord>(refreshData, BlacklistEntityType.Person),
  createMatchResolutionRequestColumn<PersonRecord>(refreshData, BlacklistEntityType.Person),
  {
    accessorKey: "createdByUser.fullName",
    header: "Created By",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "createdDate",
    header: "Created Date",
    size: 50,
    accessorFn: (row) => (row.createdDate ? formatUTCDateWithLocalTime(row.createdDate) : null),
    Cell: ({ renderedCellValue }) => <Typography variant="subtitle2">{renderedCellValue}</Typography>,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "firstName",
    header: "First Name",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "middleName",
    header: "Middle Name",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "lastName",
    header: "Last Name",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "suffix",
    header: "Suffix",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "taxID",
    header: "Tax ID",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "lookupCode",
    header: "Lookup Code",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "bulletins",
    header: "Bulletins",
    size: 900,
    Cell: ({ row }) => {
      const bulletins = row.original.bulletins;
      if (!bulletins || bulletins.length === 0) return <span>No bulletins</span>;

      return (
        <div style={{ maxHeight: "150px", overflowY: "auto" }}>
          {bulletins.map((bulletinRecord, index) => (
            <BulletinRowData key={index} bulletin={bulletinRecord.bulletin} />
          ))}
        </div>
      );
    },
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "title",
    header: "Title",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "isAttorney",
    header: "Attorney?",
    Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "isNotary",
    header: "Notary?",
    Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No"),
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "yearAdmittedToBar",
    header: "Year Admitted",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  },
  {
    accessorKey: "notes",
    header: "Notes",
    size: 50,
    muiTableBodyCellProps: { sx: { verticalAlign: "top" } },
    muiFilterTextFieldProps: { variant: "outlined", size: "small" }
  }
];
